import { t } from 'ttag'
import { actions as formActions } from 'react-redux-form'
import React from 'react'

import companies from '@h2/assets/svg/icons/companies.svg'
import occupations from '@h2/assets/svg/icons/occupations.svg'
import program from '@h2/assets/svg/icons/program.svg'
import major from '@h2/assets/svg/icons/major.svg'
import careerhub from '@h2/assets/svg/icons/userHub.svg'
import certification from '@h2/assets/svg/icons/certification.svg'
import college from '@h2/assets/svg/icons/college.svg'
import workBasedLearning from '@h2/assets/svg/icons/workBasedLearning.svg'

import { SURVEY_LOADED } from './surveys'
import {
  openContentWizard as openCContentWizard_,
  setForEdit
} from './contentSnippetWizard'

import * as h2Api from '../h2Api'

export const LOAD_PROFILE = 'PROFILE_ACTIONS_LOAD_PROFILE'
export const LOAD_PROFILE_STATS = 'PROFILE_ACTIONS_LOAD_PROFILE_STATS'
export const REORDER_SECTION = 'REORDER_SECTION'
export const CLOSE_SETUP_MODAL = 'PROFILE_CLOSE_SETUP_MODAL'
export const UPLOAD_START = 'PROFILE_SETUP_UPLOAD_START'
export const UPLOAD_DATA = 'PROFILE_SETUP_UPLOAD_DATA'
export const ADD_PERMISSIONS = 'PROFILE_ADD_PERMISSIONS'
export const LOAD_PERMISSIONS = 'PROFILE_LOAD_PERMISSIONS'
export const TOGGLE_PERMISSIONS = 'PROFILE_TOGGLE_PERMISSIONS'
export const DELETE_PERMISSIONS = 'PROFILE_DELETE_PERMISSIONS'
export const DISMISS_PERMISSION_MODAL = 'PROFILE_DISMISS_PERMISSION_MODAL'
export const TOGGLE_EDIT_MODAL = 'PROFILE_TOGGLE_EDIT_MODAL'
export const TOGGLE_TAB = 'PROFILE_TOGGLE_TAB'
export const TOGGLE_ACTIVE = 'PROFILE_TOGGLE_ACTIVE'
export const TOGGLE_DRAG = 'PROFILE_TOGGLE_DRAG'
export const DELETE_SECTION = 'PROFILE_DELETE_SECTION'
export const CLUSTER_SEARCH_UPDATE = 'CLUSTER_SEARCH_UPDATE'
export const TAGS_SEARCH_UPDATE = 'TAGS_SEARCH_UPDATE'
export const LOAD_PROMOTED = 'LOAD_PROMOTED'
export const SAVE_EVENT = 'PROFILE_SAVE_EVENT'
export const CLEAR_EVENT_ERROR = 'CLEAR_EVENT_ERROR'
export const RATE_PROFILE = 'RATE_PROFILE'
export const SELECT_MODAL_PROFILE = 'SELECT_MODAL_PROFILE'
export const APPLY_FOR_PROFILE = 'APPLY_FOR_PROFILE'

export const LOAD_WBL_TYPES = 'LOAD_WBL_TYPES'
export const TOGGLE_SURVEY_MODAL = 'PROFILE_TOGGLE_SURVEY_MODAL'

export const rateProfile = (profile, profileType, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/${profileType}_profile/${profile.id}`, {
      rating: ratingType
    })({ type: RATE_PROFILE, profileId: profile.id })
  )
}

export const toggleProfileModal = modalName => dispatch => {
  return Promise.resolve(dispatch({ type: SELECT_MODAL_PROFILE, modalName }))
}

export const guessThumbnailSrcFromUrl = url => {
  const isOccupation = /^\/profile\/\d{2}-\d{4}\.\d{2}/.test(url)
  const isCertification = /^\/profiles\/certification\/\d+/.test(url)
  const isCompany = /^\/profiles\/company\/\d+/.test(url)
  const isProgram = /^\/profiles\/program\/\d+/.test(url)
  const isMajor = /^\/majors\/detail\/\d{2}\.\d{4}/.test(url)
  const isWBLType = /^\/profiles\/offeringtype\/\d+/.test(url)
  const isInstitution =
    /^\/profiles\/institution\/\d+/.test(url) || /^\/colleges\/profile\/\d+/.test(url)

  //console.log("Guessing for " + url)
  if (isOccupation) {
    return occupations
  }

  if (isCertification) {
    return certification
  }

  if (isCompany) {
    companies
  }

  if (isProgram) {
    return program
  }

  if (isMajor) {
    return major
  }

  if (isWBLType) {
    return workBasedLearning
  }

  if (isInstitution) {
    return college
  }

  return null
}

export const guessThumbnailSrcFromType = type => {
  switch (type) {
    case 'company':
      return companies
    case 'employee':
      return careerhub
    case 'program':
      return program
    case 'institution':
      return college
    case 'certification':
      return certification
    case 'offeringtype':
      return workBasedLearning
  }
}

export const deleteSection = (profileType, profileId, draggableId) => dispatch => {
  const url = `/profiles/${profileType}/${profileId}/section/${draggableId}`

  return dispatch(
    h2Api.doDelete(url)({
      type: DELETE_SECTION
    })
  )
}

export const loadPromoted = promotedOnly => dispatch => {
  const promotedQS = promotedOnly ? `?promotedOnly=true` : ``

  return dispatch(
    h2Api.get(`/profiles/promoted${promotedQS}`)({
      type: LOAD_PROMOTED
    })
  )
}

export const toggleDrag = s => dispatch => {
  return Promise.resolve(dispatch({ type: TOGGLE_DRAG, isDragging: s }))
}

export const toggleActive = (profileType, profileId) => dispatch => {
  console.log(profileType)

  return Promise.resolve(
    dispatch(
      h2Api.put(`/profiles/${profileType}/${profileId}/activeToggle`)({
        type: TOGGLE_ACTIVE
      })
    )
  )
}

export const selectForEdit = (profileType, profileId, section) => dispatch => {
  return dispatch(openCContentWizard_(profileId, profileType)).then(() =>
    dispatch(setForEdit(section))
  )
}

export const saveProfileUpdates = (profileType, profileId, data) => dispatch => {
  console.log(data)

  return dispatch(
    h2Api.put(`/profiles/${profileType}/${profileId}`, {
      ...data,
      cluster: data.cluster,
      tags: data.tags,
      subTenant: data.subTenant && data.subTenant.id !== 'none' ? data.subTenant.id : null
    })({ type: LOAD_PROFILE })
  )
}

export const selectEditModalTab = (profileType, profileId, tabId) => dispatch => {
  if (tabId === 3) {
    const url = `/profiles/${profileType}/${profileId}/permissions`

    dispatch(
      h2Api.get(url)({
        type: LOAD_PERMISSIONS
      })
    )
  }

  return Promise.resolve(dispatch({ type: TOGGLE_TAB, selectedTab: tabId }))
}

export const toggleEditModal = (isOpen, profile) => dispatch => {
  const findIn = () => {
    if (!dynamicValues.userProfile?.isRoot) {
      return null
    }

    const tn = dynamicValues?.tenants?.find(t => t.id === profile.segment)
    const st = tn?.subTenants?.find(st => st.id === profile.subSegment)

    return st
      ? st
      : {
          id: 'none',
          name: t`Root`
        }
  }

  if (isOpen && profile) {
    dispatch(
      formActions.change('profileForms.editForm', {
        title: profile.title,
        url: profile.url,
        tags: profile.tags,
        cluster: profile.cluster,
        active: profile.active,
        subTenant: findIn()
      })
    )
    dispatch(searchTags(profile.type, profile.id))
    dispatch(searchClusters())
  } else {
    dispatch(formActions.reset('profileForms.editForm'))
  }

  return Promise.resolve(dispatch({ type: TOGGLE_EDIT_MODAL, state: isOpen }))
}

export const loadWorkBasedLearningTypes = () => {
  return h2Api.get(`/profiles/wbltypes`)({
    type: LOAD_WBL_TYPES
  })
}

export const loadPermissions = (profileType, profileId) => dispatch => {
  const url = `/profiles/${profileType}/${profileId}/permissions`

  return dispatch(
    h2Api.get(url)({
      type: LOAD_PERMISSIONS
    })
  )
}

export const deleteUserPermission =
  (profileType, profileId, permissionId) => dispatch => {
    const url = `/profiles/${profileType}/${profileId}/permissions/${permissionId}`

    return dispatch(
      h2Api.doDelete(url)({
        type: DELETE_PERMISSIONS
      })
    )
  }

export const addUserPermission = (profileType, profileId, userName) => dispatch => {
  const url = `/profiles/${profileType}/${profileId}/permissions`

  return dispatch(
    h2Api.post(url, { userName })({
      type: ADD_PERMISSIONS
    })
  )
}

export const toggleUserPermission =
  (profileType, profileId, permissionId, permissionType, enabled) => dispatch => {
    const url = `/profiles/${profileType}/${profileId}/permissions/${permissionId}/toggle`

    return dispatch(
      h2Api.post(url, { permissionType, enabled })({
        type: TOGGLE_PERMISSIONS
      })
    )
  }

export const dismissPermissions = () => dispatch => {
  dispatch({
    type: DISMISS_PERMISSION_MODAL
  })
}

export const finishProfileSetup = (profileType, profileId, d) => dispatch => {
  dispatch({ type: UPLOAD_START })
  const data = new FormData()

  data.append('title', d.title)

  if (d.about) {
    data.append('about', d.about)
  }

  if (d.logoBlob != null) {
    data.append('logo', d.logoBlob, 'logo_setup.jpg')
  }

  if (d.mastheadBlob != null) {
    data.append('masthead', d.mastheadBlob, 'masthead_setup.jpg')
  }

  const url = `/profiles/${profileType}/${profileId}/setup`

  return dispatch(
    h2Api.postFile(
      url,
      data
    )({
      type: UPLOAD_DATA
    })
  )
}

export const searchClusters = () => dispatch => {
  return dispatch(
    h2Api.get('/pathways/clusters/suggest')({ type: CLUSTER_SEARCH_UPDATE })
  )
}

export const searchTags = (profileType, profileId) => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/${profileType}/${profileId}/tags/suggest`)({
      type: TAGS_SEARCH_UPDATE
    })
  )
}

export const openSurveyModal = (surveyId, profileId) => dispatch => {
  return dispatch(
    h2Api.get(`/survey/${surveyId}`)({ type: SURVEY_LOADED, profileId })
  ).then(() => dispatch({ type: TOGGLE_SURVEY_MODAL, opened: true }))
}

export const closeSurveyModal = () => dispatch => {
  return Promise.resolve(dispatch({ type: TOGGLE_SURVEY_MODAL, opened: false }))
}

export const closeSetupModal = () => dispatch => {
  return dispatch({ type: CLOSE_SETUP_MODAL })
}

export const reorder = (profileType, profileId, pos, json) => dispatch => {
  return dispatch(
    h2Api.post(
      `/profiles/${profileType}/${profileId}/reorder/${pos}`,
      json
    )({ type: REORDER_SECTION })
  )
}

export const clearEventErrors = () => dispatch => {
  return dispatch({ type: CLEAR_EVENT_ERROR })
}

export const saveNewEvent = (profileType, profileId, sectionId, data) => dispatch => {
  return dispatch(
    h2Api.post(`/profiles/${profileType}/${profileId}/section/${sectionId}/event`, {
      ...data,
      eventDate: new Date(data.eventDate),
      endDate: new Date(data.endDate),
      surveyId: data.survey ? data.survey.id : -1
    })({ type: SAVE_EVENT })
  )
}

export const loadProfile = (profileType, profileId) => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/${profileType}/${profileId}`)({ type: LOAD_PROFILE })
  )
}

export const applyProfile = (profileType, profileId, form) => {
  return h2Api.post(
    `/profiles/${profileType}/${profileId}/apply`,
    form
  )({ type: APPLY_FOR_PROFILE })
}

export const loadProfileStats = (profileType, profileId) => dispatch => {
  return dispatch(
    h2Api.get(`/profiles/${profileType}/${profileId}/stats`)({ type: LOAD_PROFILE_STATS })
  )
}
